module.exports = __webpack_public_path__ + "img/fyt_back.e8365580.png";